export default "__VITE_PUBLIC_ASSET__1e5ceac6__"